import { cn } from '@/utils/cn';
import { Outlet } from 'react-router-dom';

export const LayoutWithoutHeader = ({
  className = '',
}: {
  className?: string;
}) => {
  // Use provided search params or get them from the URL

  return (
    <div
      className={cn(
        'flex min-h-screen items-center justify-center bg-primary',
        className,
      )}
    >
      <Outlet />
    </div>
  );
};
